import React from "react";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import {
  RenderInput,
  RenderSelect,
} from "../../Common/InputComponents/Inputs.jsx";
import {
  required,
  maxLength17,
  minLength2,
} from "../../../util/validations.js";
import { removeSpaces } from "../../../util/format.js";
import {
  tooltipFluorophores,
  tooltipIdentifierGeneExpression,
} from "../../Common/Misc/Tooltips.jsx";
import _ from "underscore";
const genomeOptions = [
  { display: "Homo sapiens", value: "Homo sapiens" },
  { display: "Mus musculus", value: "Mus musculus" },
  { display: "Rattus norvegicus", value: "Rattus norvegicus" },
];

const fluorophoreOptions = [
  { display: "FAM", value: "FAM" },
  { display: "HEX", value: "HEX" },
  { display: "Cy5", value: "Cy5" },
  { display: "Cy5.5", value: "Cy5_5" },
  { display: "EvaGreen", value: "EvaGreen" },
];

export const GeneExpressionIdentifier = ({ fields, custom }) => {
  const validatedAssayDetails = (custom && custom.validatedAssayDetails) || {};
  {
    return (
      <div>
        {fields.map((geneExpressionIdentifier, index) => {
          const validationErrorDetails = validatedAssayDetails[index];
          const changeTargetUUID = (targetUUID) => {
            custom.change(`${geneExpressionIdentifier}.uuid`, targetUUID);
            let inputIndex = geneExpressionIdentifier
              .split("]")[0]
              .split("[")[1];
            custom.actions.clearValidationMessages(inputIndex);
          };
          const resetUUID = () => {
            custom.change(`${geneExpressionIdentifier}.uuid`, "");
          };
          return (
            <div key={index} className="inputs">
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <Field
                      name={`${geneExpressionIdentifier}.identifier`}
                      placeholder="e.g., BRAF or 2597 (Gene ID)"
                      className="form-control"
                      type="text"
                      component={RenderInput}
                      normalize={removeSpaces}
                      label="Identifier:"
                      validate={[required, minLength2, maxLength17]}
                      tooltip={tooltipIdentifierGeneExpression}
                      serverValidation={validationErrorDetails}
                      changeTargetUUID={changeTargetUUID}
                      onChange={resetUUID}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <Field
                      name={`${geneExpressionIdentifier}.genome`}
                      className="form-control"
                      component={RenderSelect}
                      label="Genome:"
                    >
                      {genomeOptions &&
                        genomeOptions.map((option) => {
                          return (
                            <option key={option.value} value={option.value}>
                              {option.display}
                            </option>
                          );
                        })}
                    </Field>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <Field
                      name={`${geneExpressionIdentifier}.fluorophores`}
                      className="form-control"
                      component={RenderSelect}
                      label="Fluorophore(s):"
                      tooltip={tooltipFluorophores}
                    >
                      {fluorophoreOptions &&
                        fluorophoreOptions.map((option) => {
                          return (
                            <option key={option.value} value={option.value}>
                              {option.display}
                            </option>
                          );
                        })}
                    </Field>
                  </div>
                </div>
                {fields.length > 1 && (
                  <div className="col-md-auto">
                    <a
                      alt="Remove"
                      title="Remove"
                      className="del-field"
                      href=""
                      onClick={(e) => (
                        e.preventDefault(), fields.remove(index)
                      )}
                    >
                      <i className="fa fa-minus" aria-hidden="true"></i>
                    </a>
                  </div>
                )}
              </div>
            </div>
          );
        })}

        <div className="row">
          <div className="col">
            <div className="btn-add-target">
              <button
                className="outline rounded"
                onClick={(e) => (
                  e.preventDefault(),
                  fields.push({
                    genome: "Homo sapiens",
                    fluorophores: "FAM",
                    created_at: new Date().getTime(),
                    assayType: "Gene",
                  })
                )}
              >
                <i className="fas fa-plus" />
                &nbsp;Add Target
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

GeneExpressionIdentifier.propTypes = {
  fields: PropTypes.object.isRequired,
  custom: PropTypes.object,
};
